import React from 'react';
import styled from 'styled-components';
import Facebook from './Facebook';
import Twitter from './Twitter';
// import Line from './Line';

export default ({title, url}) => (
  <Social>
    <ul>
      <li>
        <Facebook url={url} />
      </li>
      <li>
        <Twitter url={url} title={title} />
      </li>
      {/*
      <li>
        <Line url={url} />
      </li>
      */}
    </ul>
  </Social>
);

const Social = styled.div`
  padding: 20px 10px;
  text-align: center;

  &&& {
    ul {
      margin: 0 0 10px;
      padding: 0;
      list-style: none;
      display: flex;

      li {
        margin-right: 5px;
        padding: 0px;

        button {
          display: block;
          width: 100%;
          font-size: 13px;
          letter-spacing: 0.6px;
          text-align: center;
          color: #ffffff;
          border: none;
        }

        &:nth-child(1) {
          button {
            background-color: #3b5998;
          }
        }
        &:nth-child(2) {
          button {
            background-color: #55acee;
          }
        }
        &:nth-child(3) {
          button {
            background-color: #00b900;
          }
        }
      }
    }

    > button {
      width: 100%;
      height: 42px;
      line-height: 42px;
      padding: 0;
      border-radius: 5px;
      border: solid 1px #c9d8df;
      background: transparent;
      font-size: 12px;
      letter-spacing: 0.2px;
      text-align: center;
      color: #1b2f32;
    }
  }
`;
